import { inject, Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, EMPTY, Observable, throwError } from 'rxjs';
import {
  ContractorCredentialsService,
  ContractorPinKey,
  ContractorShortCodeKey,
} from '@services/contractor-credentials.service';

const QrApiPathSegment = '/api/qr/';
const FileUploadPath = '/api/file/upload';

const QrVerifyPath = '/api/qr/verify';
const RejectedCredentialStatuses = [403, 429];

@Injectable()
export class ContractorInterceptor implements HttpInterceptor {
  private readonly router = inject(Router);
  private readonly credentials = inject(ContractorCredentialsService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const contractorPin = this.credentials.getCurrentPin();
    const contractorShortCode = this.credentials.getCurrentShortCode();
    if (contractorPin == null || contractorShortCode == null
      || !(request.url.includes(QrApiPathSegment) || request.url.includes(FileUploadPath))
      || request.url.includes(QrVerifyPath)) {
      return next.handle(request);
    }

    if (this.credentials.isSessionExpired()) {
      this.returnToPinLogin(contractorShortCode);
      return EMPTY;
    }

    return next.handle(request.clone({
      setHeaders: {
        [ContractorPinKey]: contractorPin,
        [ContractorShortCodeKey]: contractorShortCode,
      },
    })).pipe(
      catchError(error => {
        if (error instanceof HttpErrorResponse && RejectedCredentialStatuses.includes(error.status)) {
          this.returnToPinLogin(contractorShortCode);
        }
        return throwError(() => error);
      }),
    );
  }

  private returnToPinLogin(shortCode: string): void {
    this.credentials.clearContractorCredentials();
    void this.router.navigate(['/qr', shortCode]);
  }
}
